var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2817 6.15616C8.28171 5.8757 8.05436 5.64835 7.7739 5.64836L2.54343 5.64841C2.26297 5.64841 2.03562 5.87576 2.03561 6.15623C2.03561 6.43669 2.26295 6.66404 2.54342 6.66403L7.77388 6.66398C8.05435 6.66398 8.2817 6.43663 8.2817 6.15616Z",
    fill: "#4C545B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5434 7.67966C2.26294 7.67966 2.03559 7.90701 2.03559 8.18748C2.03558 8.46794 2.26293 8.69528 2.54339 8.69528L5.72004 8.69525C6.0005 8.69525 6.22785 8.4679 6.22786 8.18743C6.22786 7.90697 6.00051 7.67962 5.72005 7.67963L2.5434 7.67966Z",
    fill: "#4C545B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77392 3.61711L2.54346 3.61716C2.26299 3.61716 2.03564 3.84451 2.03564 4.12498C2.03564 4.40544 2.26298 4.63279 2.54344 4.63278L7.77391 4.63273C8.05438 4.63273 8.28173 4.40538 8.28173 4.12491C8.28173 3.84445 8.05439 3.6171 7.77392 3.61711Z",
    fill: "#4C545B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3129 11.539L10.313 2.60146C10.313 1.48143 9.40182 0.570217 8.28179 0.570228L2.03851 0.570292C0.918482 0.570303 0.00725127 1.48153 0.00723662 2.60156L0.00711976 11.5391C0.00710511 12.6591 0.918312 13.5703 2.03834 13.5703L8.16595 13.5702L8.28162 13.5702C9.28764 13.5702 10.1252 12.835 10.2853 11.8737C10.3034 11.7648 10.3129 11.653 10.3129 11.539ZM2.03836 12.5547L8.16596 12.5546L8.16868 12.5546L8.28163 12.5546C8.84116 12.5546 9.29647 12.0998 9.29727 11.5404L9.29727 11.539L9.29738 2.60147C9.29739 2.04145 8.84179 1.58585 8.28177 1.58585L2.0385 1.58592C1.47897 1.58592 1.02365 2.04075 1.02286 2.6001L1.02286 2.60155L1.02274 11.539C1.02274 12.0991 1.47834 12.5547 2.03836 12.5547Z",
    fill: "#4C545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProject);
export default __webpack_public_path__ + "static/media/myProject.8196df20539e2e937b2ba76959c9506f.svg";
export { ForwardRef as ReactComponent };